import api from "../atlasApi";

export const serviceGetCity = () => {
  return api.get("/city/", {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};
